

































































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { IUser } from "@/models/users";
import _ from "@/boot/lodash";

@Component
export default class UserSearchTable extends Mixins(
  FilteringSortingTableStore
) {
  //Props

  @Prop({ default: () => [] })
  public readonly excludedIds!: IUser["id"][];

  @Prop({ default: () => false })
  public readonly excludeInactive!: boolean;

  @Prop({ default: () => ({}) })
  public readonly manualFilters!: { [key: string]: string | number | boolean };

  @Prop({ default: null })
  public onSelect!: Function;

  @Prop({ default: true })
  public isHoverable!: boolean;

  @Prop({ default: true })
  public showTableHead!: boolean;

  @Prop({ default: true })
  public showSearch!: boolean;

  @Prop({ default: "router-link" })
  public rowTag!: string;

  @Prop({ default: false })
  public isCompact!: boolean;

  @Prop({
    default: () => (user: IUser) => ({
      to: {
        name: "adminUser",
        params: { userId: user.id }
      }
    })
  })
  public rowProps!: (user: IUser) => { [key: string]: string };

  @Prop({ default: () => () => ({}) })
  public rowEvents!: (user: IUser) => { [key: string]: Function };

  @Prop({ default: "UST1" })
  public declare id: string;

  @Prop({ default: "$users_search" })
  public declare dataScope: string;

  @Prop({ default: true })
  public declare ignoreHistory: boolean;

  @Prop({ default: 5 })
  public declare limit: number;

  @Prop({ default: 5 })
  public declare skeletonCount: number;

  @Prop({ default: false })
  public declare autoFocusSearch: boolean;

  @Prop({ default: "" })
  public declare searchedValue: boolean;

  // Data
  public queryText = "";
  public searchWithDebounce = _.debounce(this.debounceSearch, 250);
  public dataModule: DataModules = DataModules.USERS;
  public dataModuleAction = "search";

  // Lifecycle methods
  public created() {
    this.getData();
  }

  public beforeDestroy() {
    // Clear query when modal is closed
    const query = _.clone(this.$route.query);
    if (_.has(query, this.id)) {
      delete query[this.id];
      this.$router.replace({ query });
    }
  }

  @Watch("queryText")
  public onQueryTextChanged() {
    this.searchWithDebounce();
  }

  @Watch("searchedValue")
  public onSearchedValueChanged() {
    this.searchWithDebounce();
  }

  @Watch("excludedIds")
  public onExcludedIdsChanged() {
    this.getData();
  }

  public get showRecentUsers() {
    return _.isEmpty(this.queryText) && _.isEmpty(this.searchedValue);
  }

  public get queryPayload() {
    return this.showRecentUsers
      ? {
          params: {
            order: "-created_at"
          }
        }
      : {
          params: {
            query: this.queryText || this.searchedValue
          }
        };
  }

  public get excludedIdsFilter() {
    return this.excludeInactiveFilter(
      this.excludedIds.length
        ? {
            "filter[id|neq]": this.excludedIds.join(",")
          }
        : {}
    );
  }

  // Methods
  public debounceSearch() {
    this.cancelRequests();
    return this.getData();
  }

  // filters out inactive users
  public excludeInactiveFilter(filterObj) {
    if (this.excludeInactive) {
      return _.merge(filterObj, {
        "filter[active|eq]": true
      });
    } else {
      return filterObj;
    }
  }

  // overrides mixin method
  public storeGetData(params: any): Promise<any> {
    if (this.showRecentUsers)
      return this.$store.dispatch(`data/${this.dataModule}/list`, params);
    else return this.$store.dispatch(`data/${this.dataModule}/search`, params);
  }

  // overrides mixin method
  public getStoreParams(payload: any): Promise<any> {
    return _.merge(payload, this.queryPayload, {
      storeModule: this.dataModule,
      ignoreStored: true,
      params: {
        order: "firstname",
        with: "image",
        ...this.excludedIdsFilter,
        ...this.manualFilters
      }
    });
  }
}
